import styled from 'styled-components';
import { COLORS } from '@/theme';
import { Collapse } from 'antd';
import { indentPerLevel } from '../../containers/EditCategoriesPositionsContainer/constants';

export const StyledButtonWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const StyledCollapsedItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;

export const StyledCollapse = styled(Collapse)`
  .ant-collapse-header {
    align-items: center !important;
  }
`;

export const StyledCategoryItemWrapper = styled.div<{ $level: number; $canBeOpen: boolean; $isFirstLevel: boolean }>`
  /* Without this Safari renders white text on drag. */
  color: ${COLORS.BLACK};

  margin-top: ${({ $isFirstLevel }) => ($isFirstLevel ? 0 : '0.5rem')};
  padding-left: ${({ $level }) => `${$level * indentPerLevel}px`};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  ${({ $canBeOpen }) => $canBeOpen && 'cursor: pointer;'};

  div {
    border: 0;
  }
`;

export const StyledCategoryItemTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  flex-wrap: nowrap;
`;

export const StyledChevronWrapper = styled.div`
  width: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledTitle = styled.div<{ $isFirstLevel: boolean }>`
  font-weight: 600;
  white-space: nowrap;
  text-transform: ${({ $isFirstLevel }) => ($isFirstLevel ? 'uppercase' : 'none')};
`;

export const StyledTreeItemWrapper = styled.div`
  position: relative;
  width: 100%;
  cursor: pointer;
`;

export const StyledButton = styled.button<{ $level: number }>`
  // Without this Safari renders white text on drag.
  color: currentColor;

  padding-left: ${({ $level }) => `${$level * indentPerLevel}px`};
  border: 0;
  width: 100%;
  position: relative;
  background: transparent;
  margin: 0;
  border-radius: 3;
  cursor: pointer;

  div {
    border: 0;
  }
`;

export const StyledChildrenWrapper = styled.div`
  width: 100%;
`;

export const StyledPreviewWrapper = styled.div`
  background-color: ${COLORS.YELLOW_PRIMARY};
  padding: 0.5rem;
  border-radius: 3;
`;

export const StyledTreeItemTitleWrapper = styled.div<{ $isDragging: boolean; $isParentOfInstruction: boolean }>`
  padding: 0.5rem;
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  background: transparent;
  border-radius: 0;
  ${({ $isDragging }) => $isDragging && 'opacity: 0.4;'};
  ${({ $isParentOfInstruction }) => $isParentOfInstruction && 'background: transparent;'};
`;

export const StyledCategoryItemMessage = styled.div<{ $level: number; $canBeOpen: boolean }>`
  margin-top: 0.5rem;
  padding-left: ${({ $level }) => `${$level * indentPerLevel + 1.75 * 16}px`};
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
`;

export const StyledRzBadge = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 0.6875rem;
  font-weight: 600;
  line-height: 1;
  padding: 0.1875rem 0.375rem;
  border-radius: 0.25rem;
  background-color: ${COLORS.YELLOW_PRIMARY};
  color: ${COLORS.BLACK};
  white-space: nowrap;
  cursor: default;
`;

export const StyledRzTreeBadge = styled(StyledRzBadge)`
  background-color: ${COLORS.GREEN};
  color: ${COLORS.WHITE};
`;

export const StyledRzTooltip = styled.span`
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 50%;
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 11rem;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  background: ${COLORS.DARKEST_GRAY};
  color: ${COLORS.WHITE};
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateX(-50%);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.18);

  &::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 0.375rem solid transparent;
    border-bottom-color: ${COLORS.DARKEST_GRAY};
  }
`;

export const StyledRzBadgeWrap = styled.span`
  position: relative;
  display: inline-flex;
  flex-shrink: 0;

  &:hover ${StyledRzTooltip} {
    opacity: 1;
    visibility: visible;
  }
`;

export const StyledRzTooltipTitle = styled.span`
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.2;
`;

export const StyledRzTooltipName = styled.span`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.3;
`;

export const StyledRzTooltipId = styled.span`
  font-size: 0.6875rem;
  font-weight: 400;
  line-height: 1.3;
  opacity: 0.85;
`;

export const StyledMappingStats = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  flex-shrink: 0;
`;

export const StyledMappedCount = styled.span`
  color: ${COLORS.GREEN};
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1;
`;

export const StyledUnmappedCount = styled.span`
  color: ${COLORS.RED};
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1;
`;

export const StyledCountSlash = styled.span`
  color: ${COLORS.BLACK};
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1;
`;
